import { createRouter, createWebHistory } from 'vue-router';
import routes from './routes';
import useUserStore from '@/store/user';
import { ElMessage, ElNotification } from 'element-plus';

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    next();
    return;
  }

  if (
    ['Chat', 'Chatroom', 'ChatroomServiceList'].includes(to.name) ===
      ['Chat', 'Chatroom', 'ChatroomServiceList'].includes(from.name) &&
    to.params?.role !== from.params?.role
  ) {
    next();
    setTimeout(() => {
      location.reload();
    });
    return;
  }

  const userStore = useUserStore();
  if (!userStore.hasLogin) {
    ElNotification.info({
      title: '未登錄',
      message: '登錄後才能繼續進行訪問',
      type: 'warning',
      duration: 3000,
    });
    router.replace({
      path: '/login',
    });
    return;
  }

  next();
});

export default router;
